<div class="project-context dropdown" dropdown *ngIf="activeCompanName">
  <span class="label">{{ 'shared_header_company' | i18n }}:</span>
  <span *ngIf="companies.length && companies.length == 1" class="project-selector dropdown-toggle" style="cursor: text">{{activeCompanName| i18n}}</span>
  <span *ngIf="companies.length && companies.length != 1" class="project-selector dropdown-toggle" dropdownToggle>{{activeCompanName| i18n}} <i class="fa fa-angle-down"></i></span>
  <ul *dropdownMenu class="dropdown-menu">
    <li *ngFor="let company of companies">
      <a href="javascript:void(0)" (click)="changeCompany(company)">{{company.COMPANYNAME}}</a>
    </li>
  </ul>
</div>